import { render } from "./ClientTasks.vue?vue&type=template&id=2b31b20c"
import script from "./ClientTasks.vue?vue&type=script&lang=js"
export * from "./ClientTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__